<template>
    <div class="ui-field">
        <label class="ui-field__label">{{ name }}</label>
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'ui-field',
  props: ['name'],
};
</script>

<style lang="scss">
    .ui-field {
        display: block;
        margin-bottom: 10px;

        &__label {

        }
    }
</style>
